module.exports = __webpack_public_path__ + "img/modal-cl-claim.f2687ddd.svg";